import React from "react";
import styled from "styled-components";
// Composants
import TestimonialSlider from "../Elements/TestimonialSlider";
import TeamMemberBox from "../Elements/TeamMemberBox";

// Importation des images
import amineImage from "../../assets/img/team/amine.jpg";
import ahmedImage from "../../assets/img/team/ahmed.jpg";

export default function Blog() {
  return (
    <Wrapper id="equipe">
      <div className="whiteBg">
        <div className="container">
          <HeaderInfo>
            <h1 className="font40 extraBold">Rencontrez Notre Équipe</h1>
            <p className="font13">
              Faites connaissance avec les personnes talentueuses derrière nos projets. Voici quelques-uns de nos membres clés de l'équipe.
            </p>
          </HeaderInfo>
          <TeamRow className="row textCenter">
            <TeamMemberWrapper className="col-xs-12 col-sm-6 col-md-6 col-lg-6">
            <TeamMemberBox
              name="Mohamed Amine Benkhoud"
              position="Co-Fondateur - Développeur Mobile"
              description="Amine possède une vaste expérience dans le développement d'applications mobiles et s'assure de la livraison réussie des projets."
              imgSrc={amineImage}
            />
            </TeamMemberWrapper>
            <TeamMemberWrapper className="col-xs-12 col-sm-6 col-md-6 col-lg-6">
              <TeamMemberBox
                name="Ahmed Bensalem"
                position="Co-Fondateur - Développeur Web"
                description="Ahmed est un expert en développement full-stack, passionné par la création de solutions innovantes et performantes."
                imgSrc={ahmedImage}
              />
            </TeamMemberWrapper>
          </TeamRow>
          <div className="row flexCenter">
            <StyledButtonWrapper>
              <StyledButton
                onClick={() => window.open("https://www.facebook.com/profile.php?id=61558055255867", "_blank")}
              >
                En savoir plus sur nous
              </StyledButton>
            </StyledButtonWrapper>
          </div>
        </div>
      </div>
      <div className="lightBg" style={{ padding: "50px 0" }}>
        <div className="container">
          <HeaderInfo>
            <h1 className="font40 extraBold">Citations Inspirantes de Leaders en IT & Développement</h1>
            <p className="font13">
              Découvrez des citations puissantes et motivantes de certaines des personnalités les plus influentes dans les domaines de l'informatique et du développement.
            </p>
          </HeaderInfo>
          <TestimonialSlider />
        </div>
      </div>
    </Wrapper>
  );
}

// Composants stylés
const Wrapper = styled.section`
  width: 100%;
  padding-top: 20px;
`;

const HeaderInfo = styled.div`
  margin-bottom: 30px;
  @media (max-width: 860px) {
    text-align: center;
  }
`;

const TeamRow = styled.div`
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;
`;

const TeamMemberWrapper = styled.div`
  margin-bottom: 30px;
  flex: 1 1 50%;
  max-width: 50%;
  padding: 0 15px;

  @media (max-width: 768px) {
    max-width: 100%;
    flex: 1 1 100%;
  }
`;

const StyledButtonWrapper = styled.div`
  margin: 50px 0;
  width: 200px;
`;

const StyledButton = styled.button`
  border: 1px solid #1f1b59;
  background-color: #1f1b59;
  width: 100%;
  padding: 15px;
  outline: none;
  color: #fff;
  cursor: pointer;
  border-radius: 15px;
  font-size: 16px;

  &:hover {
    background-color: #27254b;
    border: 1px solid #27254b;
  }
`;
